import { useEffect, useState } from "react";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import OptimizationStoreOld from "modules/optimization-old/store/OptimizationStore"
import CashFlowTableModal from "../cash-flow-table/CashFlowTable";
import SalientFeatureModal from "modules/family-protection/components/salient-feature-modal/SalientFeatureModal";
import fetchProductLevelFeature from "modules/family-protection/components/salient-feature-modal/fetchProductLevelFeature";
import fetchProductLevelBenefits from "modules/family-protection/components/salient-feature-modal/fetchProductLevelBenefits";
import ProductGraphModal from "modules/family-protection/components/product-graph-modal/ProductGraphModal"
import AuthStore from "modules/login/store/AuthStore";
import { CHANGE_PRODUCT_CUSTOMIZATION } from "constants/UserClicksConstant";
import { Button } from "react-bootstrap";
import { toJS } from "mobx";
import CompareProductModal from "../compare-products-modal/CompareProductsModal";
import ViewBonusHistoryButton from "components/ui/view-bonus-history/ViewBonusHistoryButton"
import ViewBonusHistoryConstant from "constants/ViewBonusHistoryConstant";
import BonusHistoryModal from "../bonus-history-modal/BonusHistoryModal";
import BonusHistoryModalConstant from "constants/BonusHistoryModalConstant";

export default function ChangeProductSection(props) {
  const [isSalientFeaturesExist, setIsSalientFeaturesExist] = useState(false);
  const [showIRRValue, setshowIRRValue] = useState('View IRR');
  let currentLocation = window.location.pathname
  let store
  if (!currentLocation.includes("customization-old")) {
    store = OptimizationStore
  } else {
    store = OptimizationStoreOld
  }
  useEffect(() => {
    let features = fetchProductLevelFeature(props.productData);
    let benefits = fetchProductLevelBenefits(props.productData);

    if (features.length === 0 && benefits.length === 0) {
      setIsSalientFeaturesExist(false);
    } else {
      setIsSalientFeaturesExist(true);
    }
  }, [props.productName, props.productData]);

  const handleClick = (productData) => {
    let data = toJS(productData)
    setshowIRRValue(`IRR:  ${data?.data?.irr_value}%`);
    setTimeout(() => {
      setshowIRRValue('View IRR');
    }, 5000);
  };
  console.log("CHANGE", props.productData.data?.irr_value)
  return (
    <div>
      <Button
        className="px-2 mb-1 py-2 font-weight-bold"
        onClick={async () => {
          let response =  await OptimizationStore.fetchAllProductList(props.productData)
          response === "success" ? store.isChangeProductModalOpen = true : store.isChangeProductModalOpen = false
          // store.changeProductList = [...props.changeProductList];
          store.setChangeProductData(props.productData);
        }}

      >
        Change Product
      </Button>
      <p className="mb-2 font-size-12 font-weight-light total-premium-container-heading">
        Underlying Product
      </p>
      <div className="d-flex align-items-center ">
        <p className="mb-0 font-size-14 text-primary font-weight-medium">
          {props.productName}
        </p>
      </div>
      <div className="d-flex flex-wrap mb-2">
        {props.hideCashflowTable ? (
          ""
        ) : (
          <CashFlowTableModal
            productName={props.productName}
            familyProductId={props.familyProductId}
            cardName={props.cardName}
            productData={props.productData}
          />
        )}

        {props.hideCashflowTable ? (
          ""
        ) : (
          <ProductGraphModal
            productName={props.productName}
            familyProductId={props.familyProductId}
            cardName={props.cardName}
            productData={props.productData}
          />
        )}

        {!props.productData.data.isErrorExist && isSalientFeaturesExist && (
          <SalientFeatureModal
            productName={props.productName}
            familyProductId={props.familyProductId}
            cardName={props.cardName}
            productData={props.productData}
          />
        )}



        {/* <span
          className={`ml-0 ml-md-2 btn p-0 LA-btn font-size-14 font-size-md-12 font-weight-light ${props.changeProductList === undefined ||
            props.changeProductList?.length === 0
            ? "text-gray-opacity-49 d-none"
            : "text-primary"
            }`}
          onClick={() => {
            //! for save user clicks
            AuthStore.saveUserClicks(CHANGE_PRODUCT_CUSTOMIZATION)

            props.changeProductList === undefined ||
              props.changeProductList?.length === 0
              ? (store.isChangeProductModalOpen = false)
              : (store.isChangeProductModalOpen = true);
            store.changeProductList = [...props.changeProductList];
            store.setChangeProductData(props.productData);
          }}
        >
          {" "}
          [ Change Product ]
        </span> */}
        <CompareProductModal
          form={props.form}
          data={props.productData}
        />

        {((Number(props?.productData?.data?.irr_value) !== 0 && props?.productData?.data?.irr_value !== "")) &&
          <span className="ml-2 btn p-0 LA-btn font-size-14 text-secondary view-irr-button d-none d-md-block text-nowrap" onClick={() => { handleClick(props.productData) }} >{showIRRValue}</span>
        }

        {(ViewBonusHistoryConstant[props.productData?.data?.package_id]) &&
          <div className=" d-none d-md-block">
            <ViewBonusHistoryButton
              productData={props.productData}
              style="w-100 ml-2"
            />
          </div>
        }

        {BonusHistoryModalConstant.includes(props.productData?.data?.package_id) &&
          <div className=" d-none d-md-block">
            <BonusHistoryModal
              form={props.form}
              productName={props.productName}
              familyProductId={props.familyProductId}
              cardName={props.cardName}
              productData={props.productData}
              style={"w-100 mx-1"}
            />
          </div>
        }
      </div>
      {((Number(props?.productData?.data?.irr_value) !== 0 && props?.productData?.data?.irr_value !== "")) &&
        <span className="btn p-0 LA-btn font-size-14 text-secondary view-irr-button w-100  d-block d-md-none text-nowrap" onClick={() => { handleClick(props.productData) }} >{showIRRValue}</span>
      }
      {(ViewBonusHistoryConstant[props.productData?.data?.package_id]) &&
        <div className=" d-block d-md-none">
          <ViewBonusHistoryButton
            productData={props.productData}
            style="w-100 ml-0 mt-2"
          />
        </div>
      }

      {BonusHistoryModalConstant.includes(props.productData?.data?.package_id) &&
        <div className=" d-md-none d-block">
          <BonusHistoryModal
            form={props.form}
            productName={props.productName}
            familyProductId={props.familyProductId}
            cardName={props.cardName}
            productData={props.productData}
            style={"w-100 my-1 mx-0"}
          />
        </div>
      }
    </div>
  );
}
